var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app","dark":_vm.darkMode,"light":!_vm.darkMode}},[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('AppMenu'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }